<template>
  <div class="footer">
    <div class="footer_top">
      <div class="top">
        <div class="footer_bottom">
          <ul>
            <li
              v-for="(item, index) in list"
              :key="index"
              :class="item.zt ? 'add' : ''"
              @click="jump(item)"
              @mouseover="addtop(1, item.id)"
              @mouseout="addtop(2, item.id)"
            >
              <div style="position: relative">{{ item.txt }}</div>
            </li>
          </ul>
        </div>

        <div class="footTop">
          <div class="footer_txt2">
            <a
              style="color: #999999; text-decoration: none"
              href="https://beian.miit.gov.cn/"
              >京ICP备16063746号-1</a
            >
          </div>
          <div class="footer_txt2">
            <div
              class="iconfont icon-sangeren"
              style="float: left; fontsize: 24px; marginright: 15px; color: #8799b2"
            ></div>
            联系电话：010-68332599
          </div>
          <div class="footer_txt2">
            <div
              class="iconfont icon-youjian"
              style="float: left; fontsize: 24px; marginright: 15px; color: #8799b2"
            ></div>
            zgxhzz@vip.163.com
          </div>
          <div class="footer_txt2">
            <div
              class="iconfont icon-dizhi"
              style="float: left; fontsize: 24px; marginright: 15px; color: #8799b2"
            ></div>
            联系地址：北京市西城区北礼士路167号阜外医院院内《中国循环杂志》
          </div>
          <div class="footer_txt2">
            本系统由北京博渊星辰网络科技有限公司设计开发 技术支持电话：010-63269626
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["Visits2"],
  data() {
    return {
      list: [
        {
          id: 1,
          txt: "关于我们",
          zt: false,
          path: "/guide",
          type: false,
        },
        {
          id: 2,
          txt: "期刊目录",
          zt: false,
          path: "/browse",
          type: false,
        },
        {
          id: 3,
          txt: "在线投稿",
          zt: false,
          type: true,
        },
        {
          id: 4,
          txt: "编委会",
          zt: false,
          path: "/editorial",
          type: false,
        },
        {
          id: 5,
          txt: "作者中心",
          zt: false,
          path: "/oldmeeting",
          type: false,
        },
        {
          id: 6,
          txt: "联系我们",
          zt: false,
          path: "/contact",
          type: false,
        },
        {
          id: 7,
          txt: "阜外说心脏",
          zt: false,
          path: "https://www.fuwaionline.org.cn/m/index/special-detail/1075?sid=188",
          type: true,
        },
      ],
    };
  },
  methods: {
    jump(item) {
      if (item.type) {
        if (item.path) {
          window.open(item.path);
        } else {
          window.open("/Admin");
        }
      } else {
        this.$router.push({
          path: item.path,
        });
      }
    },
    addtop(num, id) {
      var that = this;
      if (num == 1) {
        for (var i = 0; i < that.list.length; i++) {
          if (i + 1 == id) {
            that.list[i].zt = true;
            that.list.push("1");
            that.list.pop("1");
          } else {
            that.list[i].zt = false;
            that.list.push("1");
            that.list.pop("1");
          }
        }
      } else {
        for (var i = 0; i < that.list.length; i++) {
          that.list[i].zt = false;
          that.list.push("1");
          that.list.pop("1");
        }
      }
    },
  },
  created() {},
};
</script>

<style lang="scss" scoped>
.footer {
  width: 100%;
  min-width: 1366px;
  text-align: center;

  .footer_top {
    width: 100%;
    margin: 0 auto;
    background: #eeeeee;
    padding-top: 24px;
    padding-bottom: 25px;

    .footTop {
      // border:1px solid #ccc;
      width: 40%;
      text-align: left;
      margin: 0 auto;
    }

    .top {
      margin: 0 auto;
      overflow: hidden;

      .footer_txt1,
      .footer_txt2 {
        font-size: 18px;
        font-family: Adobe Heiti Std;
        // font-weight: bold;
        color: #8799b2;
        line-height: 28px;
        margin-top: 10px;
        // float: left;
      }

      .footer_txt1 {
        margin-bottom: 10px;
      }

      .footer_txt2 {
        font-size: 16px;
        color: #999999;
      }
    }
  }

  .footer_bottom {
    width: 100%;
    height: 47px;

    // background: #EEEEEE;
    ul {
      width: 45%;
      margin: 0 auto;
      list-style: none;
      overflow: hidden;

      li {
        float: left;
        width: 14.2%;
        font-size: 17px;
        font-family: Adobe Heiti Std;
        color: #222b3d;
        line-height: 47px;
        cursor: pointer;
        overflow: hidden;

        .txt {
          width: 1px;
          height: 15px;
          background: #6d6d6d;
          margin-top: 16px;
          position: absolute;
          right: 0;
        }
      }
    }
  }
}

.add {
  color: var(--xt) !important;
  font-weight: bold;
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/components/public/footer.vue